//#region import
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Tabs, { TabContent, TabItem, TabPanel } from "components/Input/Tab";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import ReceiveTicketList from "./Receive/ReceiveTicketList";
import "./styleTicket.css"
import WithdrawTicketList from "./Withdraw/WithdrawTicketList";
import { useLocation } from "react-router";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ViewListIcon from '@mui/icons-material/ViewList';
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";
//#endregion


export default function SupplyTicket() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const tabActive = React.useMemo(() => location?.state ? location.state["tab"] : "ReceiveTicket", [location.state])
    const [isSwitch, setIsSwitch] = useState(false)
    const [isPermission, setIsPermission] = useState<boolean>(false);

    useEffect(() => {
        GetMenuPermissionParamRoute("/SupplyTicket", AxiosFn, setIsPermission, DialogFn);
    }, []);
    return (

        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Tabs id={"TabTicket"} defaultTab={tabActive} onTabChange={() => setIsSwitch(e => !e)}>
                    <TabItem id="ReceiveTicket"><AddShoppingCartIcon className="vertical-middle" />{" "}{`${I18n.SetText("Ticket.Gettingtickets")}`}</TabItem>
                    <TabItem id="WithdrawTicket"><ViewListIcon className="vertical-middle" />{" "}{`${I18n.SetText("Ticket.TicketWithdrawal")}`}</TabItem>
                    <TabContent id={"tabcontent-ticket"}>
                        <TabPanel id="ReceiveTicket">
                            <ReceiveTicketList isSwitch={isSwitch} isPermission={isPermission} />
                        </TabPanel>
                        <TabPanel id="WithdrawTicket">
                            <WithdrawTicketList isSwitch={isSwitch} isPermission={isPermission} />
                        </TabPanel>
                    </TabContent>
                </Tabs>
            </Grid>
        </Grid>
    );
}
